import {Stack, Typography, useTheme} from "@mui/material";
import React, {useState} from "react";
import {useForm} from "react-hook-form";
import {AutocompleteInput} from "../form/autocomplete.input";
import {userProfileSearch} from "../../api/userProfileService";
import {ErrorHelper} from "../../common/utils/error.helper";
import {AxiosError} from "axios";
import {UserProfile} from "../../common/models/userProfile/userProfile.model";
import {FixedRoute} from "../../common/enums/route.enum";

const UserSearchField = () => {
    const theme = useTheme();
    const [options, setOptions] = useState<UserProfile[]>([]);

    const {
        control,
    } = useForm();

    const onSelected = (value: unknown) => {
        const valueAsUser = value as UserProfile | undefined;
        if(!valueAsUser) {
            return;
        }

        window.location.assign(`/${FixedRoute.CompatibilityUser}/${valueAsUser.id}`);
    };

    const getUsers = async (value: string) => {
        try {
            const response = await userProfileSearch(value, 1, 50);

            return response?.results;
        } catch (error) {
            console.error(error);
            ErrorHelper.showErrors(error as AxiosError);
        }
    };

    const generateAutocompleteOptions = async(searchTerm: string) => {
        const autocompleteOptions = await getUsers(searchTerm);
        setOptions(autocompleteOptions?? []);
    };

    return (
        <Stack>
            <AutocompleteInput
                placeholder={"profile-url"}
                control={control}
                onSelected={onSelected}
                disableFilteringOption
                onInputChangeMethod={(value) => {
                    if(!value) {
                        setOptions([]);
                        return;
                    }

                    void generateAutocompleteOptions(value);
                }}
                hideEndAdornment
                name={"user"}
                items={options as UserProfile[]}
                getOptionLabel={(c) => (c as UserProfile).customUrlPathName as string}
                getOptionValue={(c) => (c as UserProfile).id}
                fieldMapper={(value, items) => items.find((c) => value === c)}
                valueMapper={(value, items) => value}
                startAdornmentContent={<Typography mr={'-4px'} color={theme.palette.text.disabled} >thatsme.baby/</Typography>}
            />
        </Stack>
    );
};

export default UserSearchField;